import Icon from '../components/Icon.vue'

Icon.register({
  'file-invoice': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M288 256H96V320H288V256zM377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105zM224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM64 72C64 67.6 67.6 64 72 64H152C156.4 64 160 67.6 160 72V88C160 92.4 156.4 96 152 96H72C67.6 96 64 92.4 64 88V72zM64 136C64 131.6 67.6 128 72 128H152C156.4 128 160 131.6 160 136V152C160 156.4 156.4 160 152 160H72C67.6 160 64 156.4 64 152V136zM320 440C320 444.4 316.4 448 312 448H232C227.6 448 224 444.4 224 440V424C224 419.6 227.6 416 232 416H312C316.4 416 320 419.6 320 424V440zM320 240V336C320 344.8 312.8 352 304 352H80C71.2 352 64 344.8 64 336V240C64 231.2 71.2 224 80 224H304C312.8 224 320 231.2 320 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-invoice.js
// module id = v1PX
// module chunks = 144